export enum SHADE_PICKER_TYPE {
    CAROUSEL = 'carousel',
    GRID = 'grid'
}
